import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { loadStaticPageContent } from 'redux/StaticPages/actions';
import { ssrHandler } from 'utils';

import AboutTemplate from './AboutTemplate';

const PAGE_NAME = 'about';

class About extends PureComponent {
  render() {
    if (!this.props.page || !this.props.page.data) {
      return null;
    }

    return <AboutTemplate content={this.props.page.data} />;
  }
}

About.propTypes = {
  page: PropTypes.shape({
    data: PropTypes.object,
    isFetching: PropTypes.bool.isRequired
  })
};

const mapStateToProps = (state, props) => ({
  page: state.staticPages.items.find((page) => page.name === PAGE_NAME)
});

function loadAboutData(store, nextState, replace, callback) {
  const { staticPages } = store.getState();
  const page = staticPages.items.find(({ name }) => name === PAGE_NAME);

  // if (typeof page !== 'undefined') {
  //   return callback();
  // }

  const actions = [loadStaticPageContent(PAGE_NAME)];

  ssrHandler(store.dispatch, actions, callback);
}

export default (store) => ({
  path: '/we/about/',
  component: connect(mapStateToProps)(About),
  onEnter: loadAboutData.bind(null, store)
});



// WEBPACK FOOTER //
// ./src/components/About/index.js